export default __webpack_public_path__ + "static/media/HomeBuddy_RequestedColour_PrimaryLockup.ed134254.svg";